import * as React from 'react'
import { useState, useEffect } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { twMerge } from 'tailwind-merge'
import { useSummaryDate } from '@renderer/chat/hooks'
import { useSummaryContext } from '../hooks/use-summary-context'

interface SummaryTitleProps extends React.ComponentProps<'div'> {}

export function SummaryTitle({ className, ...props }: SummaryTitleProps) {
  const { summary, isExpanded } = useSummaryContext()
  const { isToday, dayLabel } = useSummaryDate(summary)
  const [isRead, setIsRead] = useState(summary.read)

  useEffect(() => {
    setIsRead(summary.read)
  }, [summary.read])

  return (
    <div
      className={twMerge(
        'group-hover/summary-item:text-light text-md flex items-center gap-2 font-normal transition-colors',
        isToday || !isRead ? 'text-light/90' : 'text-light/60',
        isExpanded && 'text-light',
        className,
      )}
      {...props}
    >
      {dayLabel}
      <AnimatePresence initial={false}>
        {!isRead && (
          <motion.div className={'bg-yellow h-2 w-2 rounded-full'} animate={{ scale: 1 }} exit={{ scale: 0 }} />
        )}
      </AnimatePresence>
    </div>
  )
}
